/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import { useState } from '@wordpress/element';

function BlockItem({
	block,
	isInactiveBlock,
	isProActive,
	isSingleBlockActive,
	handleToggle
}) {
	const [active, setActive] = useState( !isInactiveBlock );
	const isUpcomingBlock = block.status === 'upcoming';
	const isLiveBlock = block.status === 'live';

	const wrapperClasses = classnames(
		'block-item',
		{
			'item_inactive': !active || isUpcomingBlock,
		}
	);

	const itemsBtn = ( url, text, classes ) => {
		return (
			<a href={url} className={'rv_dash-btn ' + classes} target='_blank'>{__(text)}</a>
		)
	}

	const itemsToggleAction = () => {
		return (
			<span className='rv_dash-toggle-icon'>
				<label className="rv_dash-toggle-button">
					<input
						type="checkbox"
						checked={active}
						onChange={() => {
							setActive( !active );
							handleToggle(!active, block.name)
						}}
						disabled={ isSingleBlockActive && active }
					/>
					<span className="rv_dash-slider"></span>
				</label>
				<span className='status-text'>{ __( active ? 'Active' : 'Inactive' ) }</span>
			</span>
		)
	}

	return (
		<div className={wrapperClasses}>
			<div className='block-item-left'>
				<img src={block.icon} alt={block.title} />
			</div>
			<div className='block-item-right'>
				<h3>{__(block.title)}
				{isUpcomingBlock && <span className='upcoming-badge'>{__('upcoming')}</span>}</h3>
				<p>{__(block.desc)}</p>
				{ isLiveBlock && itemsBtn( block.url, 'View Live Demos', 'rv-btn-filled' ) }
				{ ( ! isProActive && ! isUpcomingBlock ) && itemsBtn( block.pageUrl, 'Explore Pro Features', 'rv-btn-unfilled' )}
				{ isLiveBlock && itemsToggleAction()}
			</div>
		</div>
	);
};

export default BlockItem;
